import React from 'react';
import PropTypes from 'prop-types';
import { DatePicker } from 'material-ui';
import moment from 'moment';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { selectLocale } from '@lib/selectors';

class FormDatePicker extends React.Component {
  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);
  }

  onChange(event, value) {
    const { input } = this.props;
    const dateFormatted = moment(value).isValid() ? moment(value).format('YYYY-MM-DD') : '';
    input.onChange(dateFormatted);
  }

  parseValueToDate(value, currentLocale) {
    // this covers the case when the value is already a Moment object, returning a valid date from it
    if (moment.isMoment(value)) return moment(value).toDate();

    // this is assuming that when the date value are separated by "-" it's already on ISO 8601 format
    const isFormattedToISO8601 = value.includes('-');

    if (isFormattedToISO8601) {
      return moment(value).toDate();
    }

    // otherwise we need to format the date value to the correct syntax
    const dateNumbersList = value.split('/');
    const isBrazilianLocale = currentLocale === 'pt-BR';

    const dayIndex = isBrazilianLocale ? 0 : 1;
    const monthIndex = isBrazilianLocale ? 1 : 0;
    const yearIndex = 2;

    return new Date(dateNumbersList[yearIndex], Number(dateNumbersList[monthIndex]) - 1, dateNumbersList[dayIndex]);
  }

  render() {
    const {
      currentLocale,
      input,
      label,
      style,
      meta: { touched, error },
      ...custom
    } = this.props;
    const { value, ...inputProps } = input;
    const date = value ? this.parseValueToDate(value, currentLocale) : null;

    return (
      <DatePicker
        firstDayOfWeek={0}
        floatingLabelText={label}
        floatingLabelStyle={{ color: '#4E6170', fontWeight: 500 }}
        locale={currentLocale}
        DateTimeFormat={Intl.DateTimeFormat}
        textFieldStyle={{ width: '100%', fontWeight: 500 }}
        errorText={touched && error}
        value={date}
        {...inputProps}
        // https://github.com/react-dnd/react-dnd/issues/701
        onDrop={(e) => e.preventDefault()}
        {...custom}
        onChange={this.onChange}
        autoOk
        style={style}
      />
    );
  }
}

FormDatePicker.propTypes = {
  input: PropTypes.object,
  label: PropTypes.string,
  meta: PropTypes.object,
  style: PropTypes.object,
  currentLocale: PropTypes.string.isRequired,
};

const mapStateToProps = createStructuredSelector({
  currentLocale: selectLocale,
});

export default connect(mapStateToProps, null)(FormDatePicker);
